// extracted by css-extract-rspack-plugin
export default {"tableRowActions":"C1HRwBCFe546EQb9","link":"JBCw2VlOQ8mHJ6vg"};